import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getIsLayoutWithPrompt } from "../store/layout";
import { logout } from "../pages/login/login.actions";

type UseLogoutActionResult = () => void;

export const useLogoutActionWithPrompt = (): UseLogoutActionResult => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const isWithPrompt = useSelector(getIsLayoutWithPrompt);

  const defaultLogout = () => {
    dispatch(logout());
  };

  const logoutWithPrompt = () =>
    navigate(location.pathname, {
      state: {
        nextAction: defaultLogout,
      },
    });

  return isWithPrompt ? logoutWithPrompt : defaultLogout;
};
